import { createEffect, createEvent, sample } from 'effector'

import { portalProfileAPI } from '@/entities/profile/portal'
import { createHideFx } from '@/shared/ui/modal'

export const logoutConfirmed = createEvent()

export const showFx = createEffect<void, string>()
export const hideFx = createHideFx(showFx)

sample({
    clock: logoutConfirmed,
    target: [hideFx, portalProfileAPI.logout],
})
